export const productsHero = {
  eyebrow: '智慧城市产品',
  title: '三大类智慧城市产品',
  titleHighlight: '覆盖县域数字化全场景',
  subtitle: '智能视觉监控设备、商用显示与广告终端、智慧物联感知终端三大类，构建智慧城市的感知与展示底座。',
  desc: '共 12 款标准化产品终端，适配街道、园区、门店与乡村场景，点击任意产品即可查看详细介绍。',
};

export const productPacks = [
  {
    code: 'P001',
    name: 'TOMA 智能体标准包',
    icon: 'ri-robot-2-line',
    problem: '县域商户缺少 AI 能力与数字经营入口，难以触达消费者。',
    target: ['云使者', '县域数商'],
    features: ['TOMA 智能体', '数字货架', '车载卡', '微路由', '数商培训'],
    deploy: ['需求确认', '设备部署', '账号开通', '培训交付', '上线运营'],
    metrics: ['AI 入口可访问', '货架正常展示', '培训完成率'],
  },
  {
    code: 'P002',
    name: '云厨菜单消费包',
    icon: 'ri-restaurant-line',
    problem: '餐饮消费缺少数字权益与社交场景，复购与传播难。',
    target: ['云社员', '消费者'],
    features: ['菜单', '消费场景', '数币消费权益'],
    deploy: ['菜单数字化', '权益配置', '场景接入', '发布上线'],
    metrics: ['菜单可点', '权益可核销', '消费数据回流'],
  },
  {
    code: 'P003',
    name: '信用进货服务包',
    icon: 'ri-hand-coin-line',
    problem: '实体店主资金压力大，进货试错成本高。',
    target: ['云店长', '实体店主'],
    features: ['授信', '数字货架', '季度扎账', '小额试错'],
    deploy: ['授信评估', '额度开通', '货架接入', '季度对账'],
    metrics: ['授信可用', '季度扎账正常', '试错成本可控'],
  },
  {
    code: 'P004',
    name: 'ePin 溯源服务包',
    icon: 'ri-qr-code-line',
    problem: '农产品缺少身份与溯源，品质难证明、难溢价。',
    target: ['供应链企业', '农户'],
    features: ['产品上链', '品质认证', '数字身份', '数字货架'],
    deploy: ['产品上链', '品质认证', '数字身份生成', '货架绑定'],
    metrics: ['一物一码', '溯源可查', '货架可绑定'],
  },
];